import { render } from "./MemberList.vue?vue&type=template&id=31513808&scoped=true"
import script from "./MemberList.vue?vue&type=script&lang=js"
export * from "./MemberList.vue?vue&type=script&lang=js"

import "./MemberList.vue?vue&type=style&index=0&id=31513808&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31513808"]])

export default __exports__